import { Radio } from 'lucide-react';
import { lazy } from 'react';
import { msg } from '@/lib/i18n';
import { registerInvalidation } from '@/lib/realtime';
import { registerEntityTab } from '../entityTabs';
import { defineModule } from '../types';
import { liveRoute, replayRoute } from './routes';

/**
 * Live (IA §2 Operate › Live): the fleet on a map and in a list, updated in real time, a focus
 * panel per unit and a replay. Server module: telemetry (live endpoints); places and assets
 * come from the places module's web side.
 */
export const liveModule = defineModule({
  key: 'live',
  routes: [liveRoute, replayRoute],
  nav: [
    {
      key: 'live',
      label: msg('Live'),
      description: msg('What is happening now?'),
      icon: Radio,
      to: '/live',
      section: 'operate',
      order: 10,
      permission: 'live.vehicle.read',
      module: 'telemetry',
      match: ['/live', '/places'],
      children: [
        { key: 'places', label: msg('Places'), to: '/live/places', permission: 'places.place.read', match: ['/live/places', '/places'] },
        { key: 'visits', label: msg('Visits'), to: '/live/visits', permission: 'places.visit.read' },
        { key: 'replay', label: msg('Replay'), to: '/live/replay', permission: 'trips.trip.read' },
      ],
    },
  ],
  setup() {
    registerEntityTab('vehicle', {
      key: 'live',
      label: msg('Live'),
      permission: 'live.vehicle.read',
      module: 'telemetry',
      order: 15,
      component: lazy(() => import('./VehicleLiveTab')),
    });
    // Vehicle edits (name, plate, groups) show on the live list without waiting for the poll.
    registerInvalidation('vehicle', (n) => [
      ['live', 'units'],
      ['live', 'unit', n.subject_id ?? ''],
    ]);
  },
});
